import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesPdf: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.472 6.1H25.9V1.525h1.53V0H6.092v12.2h-1.52v1.52h1.52v3.05h-1.52v-3.05h-1.52v12.19h1.52v1.52h1.52V32H32V4.575h-1.53ZM7.622 18.285h4.57v4.57h-3.05v3.05h-1.52Zm22.85 12.19H7.622v-3.05H25.9v-1.52h1.53v-7.62H25.9v-1.52H7.622V1.525h16.76v6.09h6.09Zm-12.19-10.67v4.58h-1.52v1.52h-3.05v-7.62h3.05v1.52Zm6.1 1.53v1.52h-3.05v3.05h-1.52v-7.62h4.57v1.52h-3.05v1.53Z\"/><path fill=\"currentColor\" d=\"M28.952 3.045h1.52v1.53h-1.52Zm-1.52-1.52h1.52v1.52h-1.52Zm-12.19 18.28h1.52v4.58h-1.52Zm-6.1 0h1.53v1.53h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesPdf
